var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-lazy-image',{class:_vm.classes,attrs:{"src":_vm.src,"src-placeholder":_vm.srcPlaceholder},on:{"load":function($event){return _vm.$emit('load')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }